module.exports = __webpack_public_path__ + "static/media/CelestialRealmBanquetDMGINTA0023_design_clean_v002.702adf1f.webp";